<script lang="ts">
	import Icon from '$lib/components/icons/Icon.svelte';

	interface Props {
		id: string;
		text: string;
		checked?: boolean;
		onchange?: (event: Event) => void;
	}

	let {
		id,
		text,
		checked = $bindable(false),
		onchange,
	}: Props = $props();

	let focused = $state(false);

	function handlerFocus() {
		focused = !focused;
	}
</script>

<label for={id} class="flex p-0.5 items-center gap-2 max-w-max cursor-pointer">
	<input
		{id}
		type="checkbox"
		role="switch"
		class="sr-only"
		bind:checked
		{onchange}
		onfocus={handlerFocus}
		onblur={handlerFocus}
	/>
	<span
		class={[
			'rounded-full w-13 h-7.5 transition-colors shadow-michelin-switch',
			checked ? 'bg-primary' : 'bg-base-0',
			focused && 'shadow-michelin-switch-focus',
		]}
	>
		<Icon icon="bib-signature" class={['transition-transform p-3.9', checked ? 'translate-x-5.5' : 'translate-x-none']} tag="span" />
	</span>
	<span class="select-none">{text}</span>
</label>
